import { API_BASE_URL } from "../api";
import isTextTypeReport from "./isTextTypeReport";
import { openPrintPreview } from "./printPreviewHelper";


const defineCss = () => `
    .report-page {
        page-break-inside: avoid;
        page-break-after: always;
    }

    body { 
        font-family: Arial, sans-serif; 
        margin: 0; 
        padding: 15px; 
        font-size: 12px;
        line-height: 1.4;
        background: white;
    }
    
    .header-section {
        border: 2px solid #000;
        text-align: center;
        padding: 12px;
        margin-bottom: 15px;
        background: #f8f9fa;
    }
    
    .clinic-name {
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 3px;
        color: #1a1a1a;
    }
    
    .clinic-subtitle {
        font-size: 13px;
        margin-bottom: 3px;
        color: #444;
    }
    
    .clinic-address {
        font-size: 11px;
        color: #666;
    }
    
    .report-title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin: 15px 0;
        padding: 8px;
        background: #e3f2fd;
        border: 1px solid #2196f3;
        text-transform: uppercase;
        color: #1976d2;
    }
    
    .patient-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        font-size: 11px;
        border: 1px solid #ddd;
        padding: 12px;
        background: #fafafa;
    }
    
    .patient-left, .patient-right {
        width: 48%;
    }
    
    .info-line {
        margin-bottom: 4px;
        padding: 2px 0;
    }
    
    .info-label {
        display: inline-block;
        width: 90px;
        font-weight: bold;
        color: #333;
    }
    
    .info-value {
        color: #000;
    }
    
    .results-section {
        margin: 20px 0;
        /* border: 1px solid #000; */
    }
    
    .results-title {
        background: #2c5282;
        color: white;
        padding: 8px;
        text-align: center;
        font-weight: bold;
        font-size: 13px;
    }
    
    .results-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 11px;
    }
    
    .results-table th {
        background: #f1f5f9;
        border: 1px solid #000;
        padding: 8px 6px;
        text-align: center;
        font-weight: bold;
        font-size: 10px;
    }
    
    .results-table td {
        border: 1px solid #000;
        padding: 6px;
        vertical-align: top;
    }
    
    .test-name-cell {
        width: 36%;
        background: #f9f9f9;
        font-weight: 500;
        padding: 4px 8px;
        text-align: center;
    }
    
    .value-cell {
        width: 32%;
        text-align: center;
        font-weight: bold;
        padding: 4px 8px;
    }

    
    .normal-range-cell {
        width: 32%;
        text-align: center;
        font-size: 10px;
        padding: 4px 8px;
    }
    
    .signature-section {
        margin-top: 60px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    
    .technician-sign, .doctor-sign {
        text-align: center;
        width: 200px;
    }
    
    .sign-line {
        border-top: 1px solid #000;
        margin-bottom: 2px;
        display: flex;
        align-items: flex-end;
    }
    
    .sign-label {
        font-weight: bold;
        font-size: 11px;
    }
    
    .footer-note {
        margin-top: 50px;
        text-align: center;
        font-size: 10px;
        color: #666;
        border-top: 1px solid #ddd;
        padding-top: 10px;
    }
    
    @media print {
        body { 
            margin: 0; 
            padding: 15px;
        }
        .no-print { 
            display: none; 
        }
    }
    
    @page {
        margin: 12mm 10mm;
        size: A4;
    }
`;



const renderHeaderSection = () => {
    // Header section removed: the paper already has the header pre-printed.
    // Keeping the same space (approx 110px + 15px margin) blank so page layout stays aligned.
    // return `
    //     <div class="header-section">
    //         <div class="clinic-name">MEDIPLUS MEDICAL SERVICES (Pvt) LTD.</div>
    //         <div class="clinic-subtitle">The Most Advanced & Modernized Diagnostic Complex</div>
    //         <div class="clinic-address">177 R.B Road (President Road) Narayangonj Phone: 9715761</div>
    //     </div>
    // `;
    return `
        <div style="height: 110px; margin-bottom: 15px;"></div>
    `;
};


const renderPatientInfoSection = (patient, report, agent, reportCreationDate) => {
    return `
    <div class="patient-info">
        <div class="patient-left">
        <div class="info-line">
            <span class="info-label">Test Order ID:</span>
            <span class="info-value">${report.testOrder?.testOrderID || report.testOrder?.testOrderId || 'N/A'}</span>
        </div>
        <div class="info-line">
            <span class="info-label">Name:</span>
            <span class="info-value">${patient.patientName || 'N/A'}</span>
        </div>
        <div class="info-line">
            <span class="info-label">Mobile:</span>
            <span class="info-value">${patient.mobile || 'N/A'}</span>
        </div>
        <div class="info-line">
            <span class="info-label">Address:</span>
            <span class="info-value">${patient.address || 'N/A'}</span>
        </div>
        </div>
        <div class="patient-right">
        <div class="info-line">
            <span class="info-label">Report Date:</span>
            <span class="info-value">${reportCreationDate}</span>
        </div>
        <div class="info-line">
            <span class="info-label">Age:</span>
            <span class="info-value">${patient?.age || 'N/A'} Years</span>
        </div>
        <div class="info-line">
            <span class="info-label">Sex:</span>
            <span class="info-value">${patient?.gender || 'N/A'}</span>
        </div>
        <div class="info-line">
            <span class="info-label">Ref. By:</span>
            <span class="info-value">${agent?.name || 'Self'}</span>
        </div>
        </div>
    </div>
    `;
}


const renderTextTypeResult = (testName, testResult) => {
    return `
        <div style="margin-bottom: 12px;">
            <div style="font-weight: bold; font-size: 13px; margin-bottom: 4px;">${testName}</div>
            <div style="font-size: 12px; line-height: 1.4; white-space: pre-wrap;">${testResult}</div>
        </div>
    `;
}


const renderNonTextTypeResultRow = (testName, testResult, testUnit, normalValue) => {
    return `
        <tr>
            <td class="test-name-cell">${testName}</td>
            <td class="value-cell">${testResult + ' ' + testUnit}</td>
            <td class="normal-range-cell">${normalValue || 'N/A'}</td>
        </tr>
    `;
}


const renderNonTextTypeResultsSection = (results) => {
    const resultsHTML = results.map(result => renderNonTextTypeResultRow(result.test?.title || 'N/A', result.value || 'N/A', result.testUnit || 'N/A', result.normalValue || 'N/A')).join('');
    return `
        <div class="results-section">
            <div class="results-title">TEST RESULTS</div>
            <table class="results-table">
                <thead>
                    <tr>
                        <th>Test Name</th>
                        <th class="value-cell">Value</th>
                        <th>Normal Range</th>
                    </tr>
                </thead>
                <tbody>
                    ${resultsHTML}
                </tbody>
            </table>
        </div>
    `;
}

const renderSignatureSection = (preparedBy) => {
    return `
    <div class="signature-section">
        <div class="technician-sign">
            <div class="sign-line"></div>
            <div style="font-size: 14px; margin-top: 5px; text-align:left; font-weight: bold;">${preparedBy?.docName || 'Self'}</div>
            <div style="font-size: 10px; margin-top: 2px; text-align:left;">${preparedBy?.education ? preparedBy.education.split(',').join('<br>') : 'Self'}</div>
            ${preparedBy?.address ? `<div style="font-size: 10px; margin-top: 2px; text-align:left;"> ${preparedBy.address} </div>` : ''}
        </div>
        </div>
    `;
}


export const printTestReport = (report, selected_groups) => {
    const patient = report.patient || {};
    const preparedBy = report.preparedBy || {};
    const agent = report.agent || {};

    const reportCreationDate = new Date(report.createdAt).toDateString();
    const patientName = patient?.patientName || 'Unknown';
    const orderId = report.testOrder?.testOrderID || report.testOrder?.testOrderId || report.reportID || report._id || 'N/A';
    const printTitle = `Test Report - ${patientName} - ${orderId}`;

    const renderTestReport = (groupName, results, isLastGroup) => {
        const filteredResults = (results || []).filter(result => result);
        const superGroupName = filteredResults[0]?.test?.testGroup?.superGroup || groupName;
        const isTextType = isTextTypeReport(superGroupName);

        if (isTextType) {
            return filteredResults.map((result, idx) => {
                const isAbsoluteLastPage = isLastGroup && (idx === filteredResults.length - 1);
                const textPageBreakStyle = isAbsoluteLastPage ? 'page-break-after: auto;' : 'page-break-after: always;';

                return `
                    <div style="padding:18px 18px 10px 18px; margin-bottom:18px; border-radius:8px; position:relative; min-height:680px; ${textPageBreakStyle}">
                        ${renderHeaderSection()}
                        <div class="report-title">${groupName} REPORT</div>
                        ${renderPatientInfoSection(patient, report, agent, reportCreationDate)}
                        ${renderTextTypeResult(result?.test?.title || 'N/A', result.value || 'Result not available')}
                        ${renderSignatureSection(preparedBy)}
                    </div>
                `;
            }).join(' ');
        }

        const standardPageBreakStyle = isLastGroup ? 'page-break-after: auto;' : 'page-break-after: always;';

        return (`
            <div style="padding:18px 18px 10px 18px; margin-bottom:18px; border-radius:8px; position:relative; min-height:680px; ${standardPageBreakStyle}">
                ${renderHeaderSection()}
                <div class="report-title">${groupName} REPORT</div>
                ${renderPatientInfoSection(patient, report, agent, reportCreationDate)}
                ${renderNonTextTypeResultsSection(filteredResults)}
                ${renderSignatureSection(preparedBy)}
            </div>
        `);
    };

    const groupNames = Object.keys(selected_groups);

    const fullHtml = `
        <!DOCTYPE html>
        <html>
            <head>
                <title>${printTitle}</title>
                <style>
                    ${defineCss()}
                </style>
            </head>
            <body>
                ${groupNames.map((groupName, index) => {
        const isLastGroup = index === groupNames.length - 1;
        return renderTestReport(groupName, selected_groups[groupName], isLastGroup)
    }).join('')} 
            </body>
        </html>
    `;

    const updatePrintStatus = async () => {
        try {
            const res = await fetch(`${API_BASE_URL}/reports/print-status`, {
                method: 'POST',
                body: JSON.stringify({
                    isPrinted: true,
                    reportId: report._id,
                    resultIds: Object.values(selected_groups).flat().map(result => result._id)
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (res.ok) {
                console.log('Print status updated successfully');
            } else {
                console.error('Failed to update print status');
            }

        } catch (error) {
            console.error('Error updating print status:', error);
        }
    };

    openPrintPreview(fullHtml, printTitle);
    updatePrintStatus();

    console.log('Print window setup successfully completed for:', printTitle);
};